<!-- Header Section -->
<header class="header">
  <div class="logo">Kiko VPN</div>
  <nav class="navigation">
      <a href="/home">Home</a>
      <a href="/downloads">Downloads</a>
      <a href="/privacy">Privacy</a>
      <a href="/terms">Terms</a>
      <a href="/reseller">Reseller</a>
      <a href="/faq">Faq</a>
      <a href="/support">Support</a>
      <a href="/about">About Us</a>
  </nav>
</header>
<div class="privacy-container">
    <div class="privacy-header">
      <h1>Privacy Policy</h1>
    </div>
  
    <div class="privacy-content">
      <h2>Introduction</h2>
      <p>At Kiko VPN, we value your privacy and are committed to protecting your personal information. Please read our privacy policy to understand how we collect, use, and safeguard your data.</p>
  
      <h2>Information We Collect</h2>
      <p>We do not collect any user information except for device id</p>
  
      <h2>How We Use Your Information</h2>
      <p>We use the information we collect for the following purposes:</p>
      <ul>
        <li>To provide and improve our VPN services.</li>
        <li>To communicate with you about your account or service updates.</li>
        <li>To ensure the security of our services and prevent unauthorized access.</li>
      </ul>
  
      <h2>Data Security</h2>
      <p>We take security seriously and have implemented reasonable measures to protect your data from unauthorized access or disclosure. However, no method of transmission over the internet is completely secure, and we cannot guarantee the absolute security of your data.</p>
  
      <h2>Your Rights</h2>
      <p>You have the right to access, update, or delete any information we store</p>
  
      <h2>Changes to This Privacy Policy</h2>
      <p>We may update this privacy policy from time to time. Any changes will be reflected on this page with the updated date. We encourage you to review this policy periodically.</p>
  
      <h2>Contact Us</h2>
      <p>If you have any questions or concerns about our privacy policy, please contact us at <a href="mailto:kikovpnhelp@gmail.com">Support</a>.</p>
    </div>
  </div>